import {
  createParser,
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  useQueryStates,
} from 'nuqs'

const parseAsStringArrayAllowEmpty = createParser<string[]>({
  parse(queryValue) {
    if (queryValue === '') return []
    return parseAsArrayOf(parseAsString).parse(queryValue)
  },
  serialize(value: string[]) {
    return parseAsArrayOf(parseAsString).serialize(value)
  },
  eq(a, b) {
    return a.length === b.length && a.every((v, i) => v === b[i])
  },
})

export const useFiltersQueryState = () => {
  return useQueryStates(
    {
      id: parseAsInteger,
      status: parseAsStringArrayAllowEmpty.withDefault([]),
      eventName: parseAsStringArrayAllowEmpty.withDefault([]),
      search: parseAsString.withDefault(''),
    },
    {
      urlKeys: {
        id: 'id',
        status: 'status',
        eventName: 'event-name',
        search: 'search',
      },
    }
  )
}
